import jwtDecode from "jwt-decode"
import humps from "humps"

const baseToken = ref<string | null>(null)
const elevatedToken = ref<string | null>(null)

const accessToken = computed(
  () => elevatedToken.value ?? baseToken.value
)

type TokenClaims = {
  isSupervisor?: boolean
  cashierId?: string
  deviceId: string
  isLoggedIn: boolean
  tenant: string
}

const tokenClaims = computed<TokenClaims | undefined>(() =>
  accessToken.value
    ? (humps.camelizeKeys<object>(
        jwtDecode(accessToken.value)
      ) as unknown as TokenClaims)
    : undefined
)

const isPaired = computed(() => accessToken.value != null)

const isLoggedIn = computed(
  () => tokenClaims.value?.isLoggedIn ?? false
)

const isSupervisor = computed(
  () => tokenClaims.value?.isSupervisor ?? false
)

const cashierId = computed(
  () => tokenClaims.value?.cashierId
)

const clearTokens = () => {
  baseToken.value = null
  elevatedToken.value = null
}

const setElevatedToken = (value: string | null) => {
  elevatedToken.value = value
}

const setBaseToken = (value: string | null) => {
  baseToken.value = value
}

export const useAuth = () => ({
  elevatedToken: readonly(elevatedToken),
  accessToken,
  isLoggedIn,
  isSupervisor,
  cashierId,
  clearTokens,
  setElevatedToken,
  setBaseToken,
  isPaired,
})
